const items = [
  {
    id: 1,
    image: "7.jpg",
    title: "Fimlor Experience",
    tagline: "Graphic",
  },
  {
    id: 2,
    image: "8.jpg",
    title: "Fimlor Experience",
    tagline: "Graphic",
  },
  {
    id: 3,
    image: "9.jpg",
    title: "Fimlor Experience",
    tagline: "Graphic",
  },
  {
    id: 4,
    image: "10.jpg",
    title: "Fimlor Experience",
    tagline: "Graphic",
  },
  {
    id: 5,
    image: "7.jpg",
    title: "Fimlor Experience",
    tagline: "Graphic",
  },
  {
    id: 6,
    image: "8.jpg",
    title: "Fimlor Experience",
    tagline: "Graphic",
  },

  {
    id: 7,
    image: "9.jpg",
    title: "Fimlor Experience",
    tagline: "Graphic",
  },
  {
    id: 8,
    image: "10.jpg",
    title: "Fimlor Experience",
    tagline: "Graphic",
  },
  {
    id: 9,
    image: "7.jpg",
    title: "Fimlor Experience",
    tagline: "Graphic",
  },
  {
    id: 10,
    image: "8.jpg",
    title: "Fimlor Experience",
    tagline: "Graphic",
  },
  {
    id: 11,
    image: "9.jpg",
    title: "Fimlor Experience",
    tagline: "Graphic",
  },
  {
    id: 12,
    image: "10.jpg",
    title: "Fimlor Experience",
    tagline: "Graphic",
  },
];

const items3 = [
  {
    id: 1,
    image: "1.jpg",
    title: "Fimlor Experience",
    tagline: "Graphic",
  },
  {
    id: 2,
    image: "2.jpg",
    title: "Fimlor Experience",
    tagline: "Graphic",
  },
  {
    id: 3,
    image: "3.jpg",
    title: "Fimlor Experience",
    tagline: "Graphic",
  },
  {
    id: 4,
    image: "4.jpg",
    title: "Fimlor Experience",
    tagline: "Graphic",
  },
  {
    id: 5,
    image: "5.jpg",
    title: "Fimlor Experience",
    tagline: "Graphic",
  },
  {
    id: 6,
    image: "6.jpg",
    title: "Fimlor Experience",
    tagline: "Graphic",
  },

  {
    id: 7,
    image: "1.jpg",
    title: "Fimlor Experience",
    tagline: "Graphic",
  },
  {
    id: 8,
    image: "2.jpg",
    title: "Fimlor Experience",
    tagline: "Graphic",
  },
  {
    id: 9,
    image: "3.jpg",
    title: "Fimlor Experience",
    tagline: "Graphic",
  },
  {
    id: 10,
    image: "4.jpg",
    title: "Fimlor Experience",
    tagline: "Graphic",
  },
  {
    id: 11,
    image: "5.jpg",
    title: "Fimlor Experience",
    tagline: "Graphic",
  },
  {
    id: 12,
    image: "6.jpg",
    title: "Fimlor Experience",
    tagline: "Graphic",
  },
];

const itemsStaffSol = [
  {
    id: 1,
    image: "staff-solutions-1.jpg",
    title: "Recruitment & Trainings",
    tagline: "Staff Solutions",
    filter: ["all"],
  },
  {
    id: 2,
    image: "staff-solutions-2.jpg",
    title: "Recruitment & Trainings",
    tagline: "Staff Solutions",
    filter: ["all"],
  },
  {
    id: 3,
    image: "staff-solutions-3.jpg",
    title: "Recruitment & Trainings",
    tagline: "Staff Solutions",
    filter: ["all"],
  },
  {
    id: 4,
    image: "staff-solutions-4.jpg",
    title: "Recruitment & Trainings",
    tagline: "Staff Solutions",
    filter: ["all"],
  },
  {
    id: 5,
    image: "staff-solutions-5.jpg",
    title: "Recruitment & Trainings",
    tagline: "Staff Solutions",
    filter: ["all"],
  }
];

const gallerySection = {
  title: "Our work showcase",
  tabBtns: [
    {
      id: 1,
      name: "All",
      tab: "p-tab-1",
      count: 6,
    },
    {
      id: 2,
      name: "Branding",
      tab: "p-tab-2",
      count: 8,
    },
    {
      id: 3,
      name: "illustration",
      tab: "p-tab-3",
      count: 7,
    },
    {
      id: 4,
      name: "Photography",
      tab: "p-tab-4",
      count: 10,
    },
    {
      id: 5,
      name: "Web Design",
      tab: "p-tab-5",
      count: 9,
    },
  ],
  pTabs: [
    {
      id: "p-tab-1",
      items,
    },
    {
      id: "p-tab-2",
      items,
    },
    {
      id: "p-tab-3",
      items,
    },
    {
      id: "p-tab-4",
      items,
    },
    {
      id: "p-tab-5",
      items,
    },
  ],
  pTabs2: [
    {
      id: "p-tab-1",
      items: items3,
    },
    {
      id: "p-tab-2",
      items: items3,
    },
    {
      id: "p-tab-3",
      items: items3,
    },
    {
      id: "p-tab-4",
      items: items3,
    },
    {
      id: "p-tab-5",
      items: items3,
    },
  ],
};


export const gallerySectionFive = {
  title: "Recruitment & Trainings",
  tabBtns: [
    {
      id: 1,
      name: "All",
      tab: "all",
    }
  ],
  items: itemsStaffSol,
};


export default gallerySection;



export const gallerySectionThree = {
  tagline: "What We did",
  title: "Latest Projects",
  items: [
    {
      id: 1,
      image: "project-1-1.jpg",
      tagline: "Project List",
      title: "Substantial Growth",
    },
    {
      id: 2,
      image: "project-1-2.jpg",
      tagline: "Project List",
      title: "Substantial Growth",
    },
    {
      id: 3,
      image: "project-1-3.jpg",
      tagline: "Project List",
      title: "Substantial Growth",
    },
    {
      id: 4,
      image: "project-1-4.jpg",
      tagline: "Project List",
      title: "Substantial Growth",
    },
    {
      id: 5,
      image: "project-1-5.jpg",
      tagline: "Project List",
      title: "Substantial Growth",
    },
    {
      id: 6,
      image: "project-1-6.jpg",
      tagline: "Project List",
      title: "Substantial Growth",
    },
  ],
};

let itemsProjSol = [];

for (let i = 1; i <= 11; i++) {
  itemsProjSol.push({
    id: i,
    image: `project-solution-${i}.jpg`,
    tagline: "Project Solutions",
    title: "Project Solutions",
    filter: ["all"],
  })
}


export const gallerySectionProjSol = {
  title: "project solutions",
  tabBtns: [
    {
      id: 1,
      name: "All",
      tab: "all",
    },
  ],
  items: itemsProjSol,
};

let itemsEngSol = [];

for (let i = 1; i <= 7; i++) {
  itemsEngSol.push({
    id: i,
    image: `engineering-solution-${i}.jpg`,
    tagline: "Engineering Solutions",
    title: "Engineering Solutions",
    filter: ["all"],
  })
}
export const gallerySectionOne = {
  title: "Recruitment & Trainings",
  tabBtns: [
    {
      id: 1,
      name: "All",
      tab: "all",
    }
  ],
  items: itemsEngSol,
};


// Tech Solutions
let itemsTechSol = [];
const filTechSol = [
  'All',
  'VOIP',
  'Cartridges',
  'Network Products',
  'Web Camera',
  'Speakers/Headset',
  'Projector',
  'Printers/Fax/Scanners',
  'Biometric Scanners and readers',
  'Notebook/Laptop Bag',
  'LCD Monitors',
  'Keyboard/Mouse',
  'Flash Drive/SD Cards',
  'External HDD Enclosure',
  'Digital Camera/Video',
  'Cables & Connectors',
  'Bluetooth adapter',
  'Batteries & Chargers',
  'External TV box',
  'PCI Sound/TV/FM cards',
  'PCI Modem/3G Adapter',
  'DVD-RW',
  'Motherboards optical drives',
  'Memory Modules',
  'Hard Disk Drives',
  'Graphics Cards',
  'Intel Processors',
  'UPS',
  'NTP Clocks',
  'KVM Extenders',
  'Power supplies',
  'Computer cases',
  'Servers',
  'Branded computers',
  'Custom-made Computers',
  'Drones'
];
const filTechSolOwerCase = filTechSol.map(v => v.toLowerCase());
// console.log(filTechSol.length);

const tabBtnsTechSol = [];

for (let i = 0; i < 36; i++) {
  if (i === 0) {
    tabBtnsTechSol.push(
      {
        id: 1,
        name: 'All',
        tab: 'all',
      }
    );
  } else if (i === 35) {
    tabBtnsTechSol.push(
      {
        id: i,
        name: filTechSol[i],
        tab: filTechSolOwerCase[i],
      }
    );
    for (let j = i; j < 44; j++) {
      itemsTechSol.push({
        id: j,
        image: `tech-solution-${j}.jpg`,
        tagline: "Tech Solutions",
        title: filTechSolOwerCase[i],
        filter: ["all", filTechSolOwerCase[i]],
      });
    }
  } else {
    itemsTechSol.push({
      id: i,
      image: `tech-solution-${i}.jpg`,
      tagline: "Tech Solutions",
      title: filTechSolOwerCase[i],
      filter: ["all", filTechSolOwerCase[i]],
    });
    tabBtnsTechSol.push(
      {
        id: i,
        name: filTechSol[i],
        tab: filTechSolOwerCase[i],
      }
    );
  }
}


// console.log(itemsTechSol)
export const gallerySectionTechSol = {
  title: "tech solutions",
  tabBtns: tabBtnsTechSol,
  items: itemsTechSol,
};

// Energy  Solutions
let itemsEnerSol = [];

for (let i = 1; i <= 118; i++) {
  itemsEnerSol.push({
    id: i,
    image: `energy-solution-${i}.jpg`,
    tagline: "Energy Solutions",
    title: "Energy Solutions",
    filter: ["all"],
  })
}


export const gallerySectionEnerSol = {
  title: "energy solutions",
  tabBtns: [
    {
      id: 1,
      name: "All",
      tab: "all",
    },
  ],
  items: itemsEnerSol,
};

const items4 = [
  {
    id: 1,
    image: "bounty-creative-1.jpg",
    title: "Branding & Advertisement",
    tagline: "Bounty Creative",
    filter: ["all"],
  },
  {
    id: 2,
    image: "bounty-creative-2.jpg",
    title: "Branding & Advertisement",
    tagline: "Bounty Creative",
    filter: ["all"],
  },
  {
    id: 3,
    image: "bounty-creative-3.jpg",
    title: "Branding & Advertisement",
    tagline: "Bounty Creative",
    filter: ["all"],
  },
  {
    id: 4,
    image: "bounty-creative-4.jpg",
    title: "Branding & Advertisement",
    tagline: "Bounty Creative",
    filter: ["all"],
  },
  {
    id: 5,
    image: "bounty-creative-5.jpg",
    title: "Branding & Advertisement",
    tagline: "Bounty Creative",
    filter: ["all"],
  },
  {
    id: 6,
    image: "bounty-creative-6.jpg",
    title: "Branding & Advertisement",
    tagline: "Bounty Creative",
    filter: ["all"],
  },
  {
    id: 7,
    image: "bounty-creative-7.jpg",
    title: "Branding & Advertisement",
    tagline: "Bounty Creative",
    filter: ["all"],
  },
  {
    id: 8,
    image: "bounty-creative-8.jpg",
    title: "Branding & Advertisement",
    tagline: "Bounty Creative",
    filter: ["all"],
  },
  {
    id: 9,
    image: "bounty-creative-9.jpg",
    title: "Branding & Advertisement",
    tagline: "Bounty Creative",
    filter: ["all"],
  }
];

export const gallerySectionTwo = {
  title: "Bounty Creative",
  tabBtns: [
    {
      id: 1,
      name: "All",
      tab: "all",
    }
  ],
  items: items4,
};


const items5 = [
  {
    id: 1,
    image: "general-supplies-1.jpg",
    title: "Stationnary & Personal Protectice Equipment",
    tagline: "General Supplies",
    filter: ["all"],
  },
  {
    id: 2,
    image: "general-supplies-2.jpg",
    title: "Stationnary & Personal Protectice Equipment",
    tagline: "General Supplies",
    filter: ["all"],
  },
  {
    id: 3,
    image: "general-supplies-3.jpg",
    title: "Stationnary & Personal Protectice Equipment",
    tagline: "General Supplies",
    filter: ["all"],
  },
  {
    id: 4,
    image: "general-supplies-4.jpg",
    title: "Stationnary & Personal Protectice Equipment",
    tagline: "General Supplies",
    filter: ["all"],
  },
  {
    id: 5,
    image: "general-supplies-5.jpg",
    title: "Stationnary & Personal Protectice Equipment",
    tagline: "General Supplies",
    filter: ["all"],
  },
  {
    id: 6,
    image: "general-supplies-6.jpg",
    title: "Stationnary & Personal Protectice Equipment",
    tagline: "General Supplies",
    filter: ["all"],
  },
  {
    id: 7,
    image: "general-supplies-7.jpg",
    title: "Stationnary & Personal Protectice Equipment",
    tagline: "General Supplies",
    filter: ["all"],
  },
  {
    id: 8,
    image: "general-supplies-8.jpg",
    title: "Stationnary & Personal Protectice Equipment",
    tagline: "General Supplies",
    filter: ["all"],
  },
  {
    id: 9,
    image: "bounty-creative-9.jpg",
    title: "Stationnary & Personal Protectice Equipment",
    tagline: "General Supplies",
    filter: ["all"],
  }
];

export const gallerySectionFour = {
  title: "General Supplies",
  tabBtns: [
    {
      id: 1,
      name: "All",
      tab: "all",
    }
  ],
  items: items5,
};
